import React from "react";
import Button from "@/Components/Button";
import { useRouter } from "next/navigation";

interface MobileCallToActionProps {
    onContactClick: () => void;
}

const MobileCallToAction: React.FC<MobileCallToActionProps> = ({
    onContactClick,
}) => {
    const router = useRouter();

    return (
        <div className="lg:hidden flex mobilesectionWrapper mt-5 relative z-[9]">
            <div className="sectionWrapper ">
                <div className="gradientOverlay">
                    <div className="innerGradient"></div>
                </div>

                <div className=" text-center">
                    <div className="title !text-[22px] md:!text-[30px] !mb-[21px]">
                        Want to Build your own Groundbreaking Product?
                    </div>

                    <a
                        href="/request-proposal"
                        target="_blank"
                        rel="noreferrer"
                        className="text-center w-full flex justify-center items-center"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent default anchor behavior to handle navigation via router
                            onContactClick();
                            router.push("/request-proposal");
                        }}
                    >
                        <Button
                            variant="small"
                            className="w-full my-0 xl:text-subtitle-3 whitespace-nowrap lg:text-subtitle-4 xl:max-h-[auto] lg:max-h-[42px] xl:max-w-[auto] lg:max-w-[156px]"
                            label="Contact us"
                        // onClick handler removed from button to avoid double triggering, handled by anchor wrapper
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default MobileCallToAction;
